import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { logException } from 'helpers/utilities/logger';
import ErrorPage from 'pages/error/components/errorPage';
export function ClientSideErrorPage() {
    return (_jsx(ErrorPage, { headings: [
            'Sorry - we seem',
            'to be having a',
            'problem completing',
            'your request',
        ], copy: "Please try again. If the problem persists, ", reportLink: true }));
}
export class ClientSideErrorHandler extends Component {
    state = {
        hasError: false,
    };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        logException(error.message);
    }
    render() {
        if (this.state.hasError) {
            return _jsx(ClientSideErrorPage, {});
        }
        return this.props.children;
    }
}
